import { useState } from 'react';
import FestivalLinks from '../../../components/FestLinks/FestLinks';
import Footer from '../../../components/Footer/Footer';
import InnerNav from '../../../components/InnerNav/InnerNav';
import Zodiac from '../../../components/ZodiacSign/Zodiac';
import './SankrantiFest.scss';

const sankrantiFestivals = [
  {
    id: 1,
    name: 'Makar Sankranti',
    img: 'https://s3.india.com/wp-content/uploads/2025/01/Makar-Sankranti-2025_-How-India-Comes-Together-For-A-Joyful-Harvest-Celebration.jpg?impolicy=Medium_Widthonly&w=350&h=263',
    desc: 'Makar Sankranti marks the sun’s transition into Capricorn. It is celebrated with kite flying, sesame sweets, and holy dips.'
  },
  {
    id: 2,
    name: 'Pongal',
    img: 'https://i0.wp.com/www.tusktravel.com/blog/wp-content/uploads/2020/01/Pongal-Harvest-Celebrations-in-South-India.jpg?fit=1024%2C700&ssl=1',
    desc: 'Pongal is a Tamil harvest festival where rice is boiled in milk and offered to the Sun God with gratitude.'
  },
  {
    id: 3,
    name: 'Uttarayan',
    img: 'https://images.hindustantimes.com/img/2023/01/12/1600x900/FJCwh2saIAUh1W8_1673511580082_1673511607166_1673511607166.jpg',
    desc: 'Celebrated majorly in Gujarat, Uttarayan involves massive kite flying and feasts with local delicacies.'
  },
  {
    id: 4,
    name: 'Magh Bihu',
    img: 'https://images.hindustantimes.com/img/2023/01/12/1600x900/pjimage_99_1610455331469_1673522263400_1673522504602_1673522504602.jpg',
    desc: 'Assam celebrates Magh Bihu with community feasts (Uruka), bonfires, and traditional Assamese games.'
  },
  {
    id: 5,
    name: 'Shishur Sankrat',
    img: 'https://insightuk.org/wp-content/uploads/2024/01/Makar-Sankranti-768x534.jpg',
    desc: 'In Kashmir, Shishur Sankrat is observed with special meals and rituals welcoming the harsh winter season.'
  },
  {
    id: 6,
    name: 'Khichdi Parv',
    img: 'https://64.media.tumblr.com/34471513ea9a92da568e7be5b293bd83/e11dab102d00988d-b0/s500x750/56ca25ba33a6d4eb5981d8bb798ed8c3e24e53ce.png',
    desc: 'Observed in Uttar Pradesh and Bihar, Khichdi Parv involves taking holy dips and offering khichdi to Brahmins and the poor.'
  },
  {
    id: 7,
    name: 'Thai Pongal',
    img: 'https://nationaltoday.com/wp-content/uploads/2021/10/Pongal-1200x834.jpg',
    desc: 'Thai Pongal is a multi-day celebration in Tamil Nadu thanking nature and farm animals for a good harvest.'
  },
  {
    id: 8,
    name: 'Makaravilakku',
    img: 'https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSpAEor5XdTq_EIKpKJuMeWM2VB71S4Qf_O7w&s',
    desc: 'Makaravilakku is a sacred festival at Sabarimala where thousands gather to witness the holy light and offer prayers.'
  },
  {
    id: 9,
    name: 'Til Sankranti',
    img: 'https://www.thinkrightme.com/wp-content/uploads/2022/01/Untitled-design-33-1024x610.jpg',
    desc: 'Til Sankranti involves distributing sesame (til) sweets symbolizing warmth, goodwill, and friendship.'
  },
  {
    id: 10,
    name: 'Patang Festival',
    img: 'https://t3.ftcdn.net/jpg/05/77/44/28/360_F_577442831_XnXJvDNU6Lv2kRemBGW2ilfu8zkWGJO4.jpg',
    desc: 'Celebrated with enthusiasm in Gujarat and Maharashtra, Patang Festival sees colorful kites dominating the sky.'
  },
];

const SankrantiFest = () => {
  const [selectedFest, setSelectedFest] = useState(null);

  const openPopup = (fest) => {
    setSelectedFest(fest);
  };

  const closePopup = () => {
    setSelectedFest(null);
  };

  return (
    <div className="sankrantifest-container">
      <InnerNav />
      <div className="sankrantifest-content">
        <Zodiac />

        <div className="festival-header">
          <h4>Regional Celebrations of Sankranti Festival</h4>
        </div>

        <div className="festival-grid">
          {sankrantiFestivals.map((fest) => (
            <div className="festival-card" key={fest.id} onClick={() => openPopup(fest)}>
              <img
              src={fest.img || 'https://s3.india.com/wp-content/uploads/2025/01/Makar-Sankranti-2025_-How-India-Comes-Together-For-A-Joyful-Harvest-Celebration.jpg'}
                alt={fest.name}
              />
              <p>{fest.name}</p>
            </div>
          ))}
        </div>

        {selectedFest && (
          <div className="avatar-popup" onClick={closePopup}>
            <div className="avatar-popup-inner" onClick={(e) => e.stopPropagation()}>
              <button className="close-btn" onClick={closePopup}>&times;</button>
              <h3>{selectedFest.name}</h3>
              <img
              src={selectedFest.img || 'https://s3.india.com/wp-content/uploads/2025/01/Makar-Sankranti-2025_-How-India-Comes-Together-For-A-Joyful-Harvest-Celebration.jpg'}
                alt={selectedFest.name}
              />
              <p>{selectedFest.desc}</p>
            </div>
          </div>
        )}

        <FestivalLinks />
      </div>
      <Footer />
    </div>
  );
};

export default SankrantiFest;
